var map = {
	"./drdoctor/img/icons/new_legal_documents_icon.png": 638,
	"./freedoctor/img/icons/new_legal_documents_icon.png": 639,
	"./freelegal/img/icons/new_legal_documents_icon.png": 640,
	"./legalchief/img/icons/new_legal_documents_icon.png": 641,
	"./medi4u/img/icons/new_legal_documents_icon.png": 642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 637;